module.exports = __webpack_public_path__ + "images/category_lp/pc/crown_b2511a669049e20f718a97aa07d88192.png";